module.exports = __webpack_public_path__ + "img/road-sign.57dc7d53.svg";